import { render, staticRenderFns } from "./TreeSelectorComponent.vue?vue&type=template&id=4cbb32eb&scoped=true"
import script from "./TreeSelectorComponent.js?vue&type=script&lang=js&external"
export * from "./TreeSelectorComponent.js?vue&type=script&lang=js&external"
import style0 from "./TreeSelectorComponent.vue?vue&type=style&index=0&id=4cbb32eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbb32eb",
  null
  
)

export default component.exports